import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { memoizeDeep, safeMerge } from "../common/utilities";
const setTheme = memoizeDeep(function (_ref) {
  let {
    step,
    status,
    orientation,
    activeStatusIcon
  } = _ref;
  let cssRoot = {},
      cssWrapper = {},
      cssOuter = {},
      cssInner = {},
      cssLabelContainer = {},
      cssRailContainer = {},
      cssStepRail = {},
      cssCompletedStatusIcon = {};

  if (step) {
    cssRoot = safeMerge(cssRoot, step.root);
    const {
      completedStatusIcon,
      activeIcon
    } = step.modifiers;
    const cssOrientation = step.modifiers[orientation];
    const {
      wrapper,
      railContainer,
      stepRail,
      labelContainer
    } = cssOrientation;
    const {
      inner,
      labelContainer: statusBasedLabelContainer = {},
      stepRail: stausBaseStepRail = {},
      railContainer: statusBaseRailContainer = {}
    } = cssOrientation[status];
    cssWrapper = safeMerge(cssWrapper, wrapper);
    let {
      outer
    } = cssOrientation[status];

    if (activeStatusIcon) {
      outer = _objectSpread(_objectSpread({}, outer), activeIcon);
    }

    cssOuter = safeMerge(cssOuter, outer);
    cssRailContainer = safeMerge(cssRailContainer, _objectSpread(_objectSpread({}, railContainer), statusBaseRailContainer));
    cssInner = safeMerge(cssInner, inner);
    cssLabelContainer = safeMerge(cssLabelContainer, _objectSpread(_objectSpread({}, labelContainer), statusBasedLabelContainer));
    cssStepRail = safeMerge(cssStepRail, _objectSpread(_objectSpread({}, stepRail), stausBaseStepRail));
    cssCompletedStatusIcon = safeMerge(cssCompletedStatusIcon, _objectSpread({}, completedStatusIcon));
  }

  return {
    cssRoot,
    cssWrapper,
    cssOuter,
    cssInner,
    cssLabelContainer,
    cssRailContainer,
    cssStepRail,
    cssCompletedStatusIcon
  };
});
export default function (_ref2) {
  var _theme$components;

  let {
    theme,
    status,
    orientation,
    activeStatusIcon
  } = _ref2;
  const step = theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.step;
  return setTheme({
    step,
    status,
    orientation,
    activeStatusIcon
  });
}